<template>
 
    <!-- v-lazy-image per il caricamento dell'immagine con gestione dello skeleton -->
    <div :class="isLoading ? 'image' : 'hidden'"></div>
    <v-lazy-image v-if="srcset"
      :srcset="srcset"
      :class="className"
      :style="style"
      :alt="alt"
      use-picture
      @load="onImageLoad"
    >
    <source :srcset="srcset" />
    </v-lazy-image>

    <v-lazy-image v-else"
      :src="src"
      :sizes="size"
      :class="className"
      :style="style"
      :alt="alt"
      @load="onImageLoad"
    />
    
</template>

<script>
import VLazyImage from 'v-lazy-image';

export default {
  components: {
    VLazyImage
  },
  props: {
   className: {
    type:String,
    default:''
    },
    style:{
      type: String,
      required:false,
      default:''
    },
    src: {
      type: String,
      required: true
    },
    alt:{
      type:String,
      required:false,
      default: ''
    },
    srcset:{
      type:String,
      required:false,
      default:''
    },
    size:{
      type: String,
       default:'',
       required:false

    }
  },

  data() {
    return {
      isLoading: true // Stato di caricamento dell'immagine
    };
  },
  
  methods: {
    onImageLoad() {
      this.isLoading = false; // Imposta il caricamento a false quando l'immagine è completamente caricata
    }
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  width: 100%;
  height: 100%; /* Imposta l'altezza desiderata o rendila dinamica */
  position: absolute;
}

.image {
    width: 100vw;
    height: 100%;
    background-color: #ffffff;
    background-image: linear-gradient(90deg, #ffffff, #ffffff, #ffffff);
    background-size: 200% 100%;
    animation: loading-a7e1cfa2 1.5s infinite linear;
    display: block;
  &:before{
    content: '';
    position: absolute;
    top: 0;
    left: -150%;
    width: 100%;
    height: 25%;
    background: linear-gradient(to right, transparent 0%, #e0e0e0 50%, transparent 100%);
    animation: shimmer 2s infinite;
    margin:auto;
    bottom:0;
  }
  
  @keyframes shimmer {
    0% {
      left: -150%;
    }
    50% {
      left: 100%;
    }
    100% {
      left: -150%;
    }
  }
}

@keyframes loading {
  from {
    background-position: -200% 0;
  }
  to {
    background-position: 200% 0;
  }
}

.v-lazy-image-loaded {
  animation: none; /* Ferma l'animazione una volta caricata l'immagine */
  background: none;
}
</style>
